var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messageType)?_c('eco-checkbox',{attrs:{"options":_vm.messageType,"permission":"w"},model:{value:(_vm.checkBoxVal),callback:function ($$v) {_vm.checkBoxVal=$$v},expression:"checkBoxVal"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }